var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAttachments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-folder",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}svg#freepik_stories-folder:not(.animated) .animable{opacity:0}svg#freepik_stories-folder.animated #freepik--folder--inject-33{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33",
    className: "animable",
    style: {
      transformOrigin: "250px 331.2px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-33",
    cx: 250,
    cy: 331.2,
    rx: 237.13,
    ry: 152.37,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 331.2px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-33",
    className: "animable",
    style: {
      transformOrigin: "253.223px 296.012px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-33",
    d: "m226.54 210.11 68.79-39.71a3.33 3.33 0 0 1 3 0l50.17 29a.92.92 0 0 1 0 1.74l-68.79 39.71a3.33 3.33 0 0 1-3 0l-50.17-29a.92.92 0 0 1 0-1.74Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "287.52px 205.625px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-33",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "203.15px 347.64px"
    },
    className: "animable",
    d: "m139.73 421.98-65.34-37.73L266.57 273.3l65.34 37.72-192.18 110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 367.52c-11 6.35-11 16.63 0 23s28.79 6.34 39.78 0 11-16.62 0-23-28.8-6.34-39.78 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "74.3881px 379.018px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.9 341.69c-20.2 11.66-20.2 30.57 0 42.23s53 11.67 73.16 0 20.2-30.57 0-42.23-52.96-11.69-73.16 0Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "408.473px 362.801px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-33",
    className: "animable",
    style: {
      transformOrigin: "298.49px 136.5px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-33",
    className: "animable",
    style: {
      transformOrigin: "298.49px 136.5px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "287.525px 136.5px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "256.485px 154.42px"
    },
    id: "elvg8yrk37ch",
    className: "animable",
    d: "m278.21 235.06-43.45-25.09V73.78l43.45 25.09v136.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "309.25px 149.045px"
    },
    id: "elrqzpkhe6sd",
    className: "animable",
    d: "m278.21 98.87 62.08-35.84v136.19l-62.08 35.84V98.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "287.525px 68.405px"
    },
    id: "el4uq81sad2z",
    className: "animable",
    d: "m340.29 63.03-62.08 35.84-43.45-25.09 62.08-35.84 43.45 25.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "309.82px 190.385px"
    },
    id: "elwnjjc469xqe",
    className: "animable",
    d: "m284.42 187.13 49.66-28.67v34.52l1.14.66-49.66 28.67-1.14-.66v-34.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "310.39px 190.715px"
    },
    id: "elzaysna6avu9",
    className: "animable",
    d: "m285.56 187.79 49.66-28.67v34.52l-49.66 28.67v-34.52z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05,
      transformOrigin: "310.39px 190.715px"
    },
    className: "animable",
    id: "el8hdq0rq6g1l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "el67j7buk85ol",
    className: "animable",
    style: {
      transformOrigin: "310.39px 190.715px"
    },
    d: "m285.56 187.79 49.66-28.67v34.52l-49.66 28.67v-34.52z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305 182.41 8.44-4.88c1.1-.63 2-.34 2 .65a4 4 0 0 1-2 2.93L305 186c-1.1.63-2 .34-2-.65a4 4 0 0 1 2-2.94Z",
    style: {
      fill: "#263238",
      transformOrigin: "309.22px 181.765px"
    },
    id: "elt5r88e05cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "309.82px 148.71px"
    },
    id: "el0athzoj45awr",
    className: "animable",
    d: "m284.42 145.46 49.66-28.67v34.51l1.14.66-49.66 28.67-1.14-.66v-34.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "310.39px 149.04px"
    },
    id: "ele2mjvrw13xf",
    className: "animable",
    d: "m285.56 146.12 49.66-28.67v34.51l-49.66 28.67v-34.51z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05,
      transformOrigin: "310.39px 149.04px"
    },
    className: "animable",
    id: "elt3suxlj785g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "el1s2fs2aiqqo",
    className: "animable",
    style: {
      transformOrigin: "310.39px 149.04px"
    },
    d: "m285.56 146.12 49.66-28.67v34.51l-49.66 28.67v-34.51z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305 140.73 8.44-4.88c1.1-.63 2-.34 2 .65a4 4 0 0 1-2 2.94l-8.44 4.87c-1.1.64-2 .35-2-.64a4 4 0 0 1 2-2.94Z",
    style: {
      fill: "#263238",
      transformOrigin: "309.22px 140.084px"
    },
    id: "el9y4ml99bn0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "309.25px 106.7px"
    },
    id: "el721qudkgzx",
    className: "animable",
    d: "m284.42 103.78 49.66-28.67v34.51l-49.66 28.67v-34.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-33",
    className: "animable",
    style: {
      transformOrigin: "323.89px 116.405px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "345.135px 102.54px"
    },
    id: "elv6hlpf6r52",
    className: "animable",
    d: "m358.91 95.29-27.55-15.9v30.4l27.55 15.9v-30.4z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "345.135px 102.54px"
    },
    className: "animable",
    id: "el6lt3d17haes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elwhnuqtef3gl",
    className: "animable",
    style: {
      transformOrigin: "345.135px 102.54px"
    },
    d: "m358.91 95.29-27.55-15.9v30.4l27.55 15.9v-30.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "346.1px 86.78px"
    },
    id: "elb8ag2f6038i",
    className: "animable",
    d: "m333.28 78.27-1.92 1.11 27.55 15.91 1.93-1.12-27.56-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 81.63a.71.71 0 0 0-.26-.62h-.07l-1.41-.81a.69.69 0 0 0-.68.07l-28.03 16.14-.82-3.3a.91.91 0 0 0-.4-.54l-1.46-.85a.85.85 0 0 0-.88 0l-11.94 6.89a2.15 2.15 0 0 0-1 1.69v39.81a.69.69 0 0 0 .26.62l1.5.87a.68.68 0 0 0 .66-.08l43.59-25.17a2.13 2.13 0 0 0 1-1.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "317.553px 110.896px"
    },
    id: "elq3j3jva8x2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 81.63v33.07a2.12 2.12 0 0 1-1 1.68l-43.7 25.23a.57.57 0 0 1-.86-.49v-39.95a2 2 0 0 1 .28-1 2.11 2.11 0 0 1 .69-.73l11.94-6.89a.88.88 0 0 1 .87 0 .86.86 0 0 1 .4.53l.82 3.3.13.35a.85.85 0 0 0 1.3.52l28.09-16.21a.73.73 0 0 1 .64-.09.68.68 0 0 1 .4.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "318.221px 111.301px"
    },
    id: "elq9jrlg2anh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 81.63v33.07a2.12 2.12 0 0 1-1 1.68l-43.7 25.23a.57.57 0 0 1-.86-.49v-39.95a2 2 0 0 1 .28-1 2.11 2.11 0 0 1 .69-.73l11.94-6.89a.88.88 0 0 1 .87 0 .86.86 0 0 1 .4.53l.82 3.3.13.35a.85.85 0 0 0 1.3.52l28.09-16.21a.73.73 0 0 1 .64-.09.68.68 0 0 1 .4.68Z",
    style: {
      opacity: 0.15,
      transformOrigin: "318.221px 111.301px"
    },
    className: "animable",
    id: "el7vdso4x5uw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.88 141.64-1.5-.87a.72.72 0 0 1-.27-.62v-39.83a2.05 2.05 0 0 1 .29-.95l1.45.85a2 2 0 0 0-.28 1v40a.56.56 0 0 0 .31.42Z",
    style: {
      opacity: 0.35,
      transformOrigin: "294.994px 120.505px"
    },
    className: "animable",
    id: "elqcg5tf4tcn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72 84.36a.71.71 0 0 0-.26-.62h-.07l-1.39-.86a.69.69 0 0 0-.68.07l-28.09 16.18-.82-3.29a.91.91 0 0 0-.4-.54l-1.46-.85a.86.86 0 0 0-.89 0l-11.94 6.89a2.16 2.16 0 0 0-1 1.68v39.82a.66.66 0 0 0 .27.61l1.5.88a.74.74 0 0 0 .66-.08l43.59-25.17a2.16 2.16 0 0 0 1-1.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "322.228px 113.597px"
    },
    id: "elej5h39eiqw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 95.29a.85.85 0 0 0-.87 0l-11.94 6.89a2 2 0 0 0-.69.72l-1.5-.8a1.93 1.93 0 0 1 .68-.73l11.94-6.89a.86.86 0 0 1 .89 0Z",
    style: {
      fill: "#fff",
      opacity: 0.15,
      transformOrigin: "306.5px 98.628px"
    },
    className: "animable",
    id: "el93j7acdfusr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39 83.7a.74.74 0 0 0-.64.1L316.66 100a.85.85 0 0 1-1.3-.51l-.13-.36L343.3 83a.85.85 0 0 1 .43-.13.51.51 0 0 1 .25.06Z",
    style: {
      fill: "#fff",
      opacity: 0.15,
      transformOrigin: "330.31px 91.5068px"
    },
    className: "animable",
    id: "elhprs4aqznkb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72 84.36v33.07a2.16 2.16 0 0 1-1 1.68l-43.7 25.23a.57.57 0 0 1-.86-.49V103.9a2 2 0 0 1 .28-1 2 2 0 0 1 .69-.73l11.94-6.89a.88.88 0 0 1 .87 0 .91.91 0 0 1 .4.54l.82 3.29.13.36a.85.85 0 0 0 1.29.52l28.1-16.21a.72.72 0 0 1 .63-.1.71.71 0 0 1 .41.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "322.94px 114.033px"
    },
    id: "elmdb4gwymtwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.56 144.37-1.51-.87a.71.71 0 0 1-.26-.62v-39.83a1.91 1.91 0 0 1 .29-1l1.45.84a2 2 0 0 0-.28 1v39.94a.56.56 0 0 0 .31.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "299.673px 123.21px"
    },
    className: "animable",
    id: "elo8ptc4d21va"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4 87.08a.66.66 0 0 0-.27-.61h-.07l-1.4-.82a.68.68 0 0 0-.69.07l-28.06 16.18-.82-3.3a.91.91 0 0 0-.4-.53l-1.46-.85a.87.87 0 0 0-.89 0l-11.94 6.88a2.16 2.16 0 0 0-1 1.68v39.82a.69.69 0 0 0 .26.61l1.51.87a.68.68 0 0 0 .66-.08l43.59-25.16a2.18 2.18 0 0 0 1-1.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "326.908px 116.359px"
    },
    id: "elybjzlo925wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.67 98a.88.88 0 0 0-.87 0l-11.94 6.89a2.11 2.11 0 0 0-.69.73l-1.45-.85a1.89 1.89 0 0 1 .68-.72l11.94-6.89a.89.89 0 0 1 .89 0Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "311.195px 101.33px"
    },
    className: "animable",
    id: "elt51nxsu1w4m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.06 86.43a.71.71 0 0 0-.63.09l-28.1 16.21a.84.84 0 0 1-1.29-.52l-.13-.35L348 85.68a.9.9 0 0 1 .43-.14.49.49 0 0 1 .25.07Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "334.985px 94.2065px"
    },
    className: "animable",
    id: "elbiksa6qvqpj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4 87.08v33.08a2.14 2.14 0 0 1-1 1.68l-43.7 25.23a.57.57 0 0 1-.85-.5v-39.94a1.93 1.93 0 0 1 .28-1 2.06 2.06 0 0 1 .68-.72l11.94-6.9a.89.89 0 0 1 .88 0 .92.92 0 0 1 .41.54l.82 3.29.13.36a.84.84 0 0 0 1.29.51l28.1-16.21a.71.71 0 0 1 .63-.09.67.67 0 0 1 .39.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.626px 116.758px"
    },
    id: "elwsq2lays49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4 87.08v33.08a2.14 2.14 0 0 1-1 1.68l-43.7 25.23a.57.57 0 0 1-.85-.5v-39.94a1.93 1.93 0 0 1 .28-1 2.06 2.06 0 0 1 .68-.72l11.94-6.9a.89.89 0 0 1 .88 0 .92.92 0 0 1 .41.54l.82 3.29.13.36a.84.84 0 0 0 1.29.51l28.1-16.21a.71.71 0 0 1 .63-.09.67.67 0 0 1 .39.67Z",
    style: {
      fill: "#fff",
      opacity: 0.15,
      transformOrigin: "327.626px 116.758px"
    },
    className: "animable",
    id: "elc5qhu5hxiof"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.24 147.1-1.51-.87a.71.71 0 0 1-.26-.61v-39.84a2 2 0 0 1 .29-1l1.45.85a2 2 0 0 0-.28 1v39.94a.56.56 0 0 0 .31.53Z",
    style: {
      opacity: 0.05,
      transformOrigin: "304.354px 125.94px"
    },
    className: "animable",
    id: "el2vp8bdv4aum"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08 89.81a.66.66 0 0 0-.27-.61h-.07l-1.4-.82a.69.69 0 0 0-.68.07l-28.06 16.19-.82-3.3a.92.92 0 0 0-.41-.54l-1.46-.85a.86.86 0 0 0-.89 0l-11.94 6.9a2.12 2.12 0 0 0-1 1.68v39.81a.71.71 0 0 0 .26.62l1.5.87a.7.7 0 0 0 .67-.08l43.58-25.17a2.14 2.14 0 0 0 1-1.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.583px 119.101px"
    },
    id: "elb6cgxjfyl1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34 100.74a.88.88 0 0 0-.87 0l-11.94 6.89a2.09 2.09 0 0 0-.68.73l-1.46-.85a2.11 2.11 0 0 1 .69-.73L321 99.93a.86.86 0 0 1 .89 0Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "315.865px 104.083px"
    },
    className: "animable",
    id: "elv3z47df9gnk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.74 89.16a.68.68 0 0 0-.63.09L326 105.46a.84.84 0 0 1-1.29-.52l-.13-.35 28.07-16.19a.85.85 0 0 1 .43-.13.49.49 0 0 1 .25.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "339.66px 96.9364px"
    },
    className: "animable",
    id: "elauzx3uu3ybp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08 89.81v33.07a2.15 2.15 0 0 1-1 1.69l-43.7 25.22a.57.57 0 0 1-.86-.49v-40a1.94 1.94 0 0 1 .29-.95 2 2 0 0 1 .68-.72l11.94-6.9a.88.88 0 0 1 .87 0 .87.87 0 0 1 .41.53l.82 3.3.13.35a.84.84 0 0 0 1.29.52l28.1-16.21a.71.71 0 0 1 .63-.09.69.69 0 0 1 .4.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "332.301px 119.481px"
    },
    id: "el4tk6mynxdqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08 89.81v33.07a2.15 2.15 0 0 1-1 1.69l-43.7 25.22a.57.57 0 0 1-.86-.49v-40a1.94 1.94 0 0 1 .29-.95 2 2 0 0 1 .68-.72l11.94-6.9a.88.88 0 0 1 .87 0 .87.87 0 0 1 .41.53l.82 3.3.13.35a.84.84 0 0 0 1.29.52l28.1-16.21a.71.71 0 0 1 .63-.09.69.69 0 0 1 .4.68Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "332.301px 119.481px"
    },
    className: "animable",
    id: "el3tc8ueyy6bf"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "299.335px 128.98px"
    },
    id: "elaq3nv8750i8",
    className: "animable",
    d: "m313.11 121.73-27.55-15.9v30.4l27.55 15.9v-30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "300.3px 113.22px"
    },
    id: "eleu1moe8t21b",
    className: "animable",
    d: "m287.49 104.71-1.93 1.11 27.55 15.91 1.93-1.12-27.55-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "337.39px 122.95px"
    },
    id: "elyl50f2c4nik",
    className: "animable",
    d: "m312.56 120.03 49.66-28.67v34.51l-49.66 28.67v-34.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332 114.64 8.45-4.88c1.1-.63 2-.34 2 .65a4 4 0 0 1-2 2.94l-8.45 4.87c-1.09.63-2 .34-2-.64a4 4 0 0 1 2-2.94Z",
    style: {
      fill: "#263238",
      transformOrigin: "336.225px 113.99px"
    },
    id: "elrmcic2o2sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "311.73px 136.805px"
    },
    id: "elc6cm12dzy15",
    className: "animable",
    d: "m312.56 120.03-1.66-.96v34.52l1.66.95v-34.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "336.56px 105.215px"
    },
    id: "elrchlinl0oa",
    className: "animable",
    d: "m310.9 119.07 49.66-28.67 1.66.96-49.66 28.67-1.66-.96z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-33",
    className: "animable",
    style: {
      transformOrigin: "131.809px 180.169px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-33",
    className: "animable",
    style: {
      transformOrigin: "131.809px 180.169px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "131.809px 180.169px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.3 49a1.35 1.35 0 0 0-.06-.35.11.11 0 0 0 0-.08 1.15 1.15 0 0 0-.09-.33 1.67 1.67 0 0 0-.22-.49.69.69 0 0 0-.13-.2.76.76 0 0 0-.11-.14 1.18 1.18 0 0 0-.25-.25 2.07 2.07 0 0 0-.32-.19 2.8 2.8 0 0 0-2.57.33L47 148a8.46 8.46 0 0 0-3.82 6.62V313.7a2.64 2.64 0 0 0 1.32 2.3.91.91 0 0 1 .17.09l.2.11a1.17 1.17 0 0 0 .33.11 2 2 0 0 0 .49.07A2.5 2.5 0 0 0 47 316h.1l3.64-2.1 170.81-98.68a8.44 8.44 0 0 0 3.82-6.62V49.44a3.64 3.64 0 0 0-.07-.44Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "134.275px 181.589px"
    },
    id: "elo69xk0vj6q9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2 47.64a1.22 1.22 0 0 1 .5.11l.11.06h.06l.07.07.06.12.07.12a1 1 0 0 1 .11.23.64.64 0 0 0 0 .07.27.27 0 0 1 0 .11v160.04a7.54 7.54 0 0 1-3.36 5.82L50.24 313.06l-3.61 2.09-.1.06a1.67 1.67 0 0 1-.75.24h-.05a1.17 1.17 0 0 1-.29 0h-.11l-.13-.07-.14-.08h-.08a1.68 1.68 0 0 1-.88-1.49V154.63a7.56 7.56 0 0 1 3.36-5.82L222 48a2.56 2.56 0 0 1 1.23-.4m0-.92a3.43 3.43 0 0 0-1.69.51L47 148a8.46 8.46 0 0 0-3.82 6.62V313.7a2.64 2.64 0 0 0 1.32 2.3.91.91 0 0 1 .17.09l.2.11a1.17 1.17 0 0 0 .33.11 2 2 0 0 0 .49.07h.05A2.51 2.51 0 0 0 47 316h.1l3.64-2.1 170.81-98.68a8.44 8.44 0 0 0 3.82-6.62V49.44a3.64 3.64 0 0 0 0-.48 1.35 1.35 0 0 0-.06-.35.11.11 0 0 0 0-.08 1.15 1.15 0 0 0-.09-.33 1.67 1.67 0 0 0-.22-.49.69.69 0 0 0-.13-.2.76.76 0 0 0-.11-.14 1.18 1.18 0 0 0-.25-.25 2.07 2.07 0 0 0-.32-.19 2.13 2.13 0 0 0-.88-.18Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "134.279px 181.53px"
    },
    id: "eln7tbhrj0gva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.5 316-.2-.11-4-2.33a4 4 0 0 1-2-3 3.43 3.43 0 0 1 0-.56V159.18l4.83 2.82v151.8a2.57 2.57 0 0 0 1.35 2.2Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "41.3943px 237.59px"
    },
    id: "elengwwboggqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08 46.9a2.8 2.8 0 0 0-2.57.33L47 148a8.46 8.46 0 0 0-3.82 6.62V162l-4.88-2.86v-7.32a8.44 8.44 0 0 1 3.81-6.61L216.63 44.47a2.64 2.64 0 0 1 2.77-.22c.69.41 3.86 2.23 4.68 2.65Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "131.19px 102.979px"
    },
    id: "el6t2vfrm9fy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32 49.41c0-2.41-1.72-3.39-3.82-2.17L47 148a8.45 8.45 0 0 0-3.82 6.62V162L225.32 56.87Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "134.25px 104.357px"
    },
    id: "elms6jvn2pvrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24 159.19v-7.34a7.9 7.9 0 0 1 1.17-3.85l4.87 2.8a7.72 7.72 0 0 0-1.15 3.8v7.4Z",
    style: {
      opacity: 0.15,
      transformOrigin: "41.26px 155px"
    },
    className: "animable",
    id: "el1mp0bdhr9b3h"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "215.49px 56.4694px"
    },
    className: "animable",
    id: "elugw7vtas9j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.27 57.26a3.81 3.81 0 0 0-1.46 3.07c0 1.23.65 1.86 1.46 1.4a3.85 3.85 0 0 0 1.45-3.08c0-1.23-.65-1.86-1.45-1.39Z",
    id: "elcb11yydyetw",
    className: "animable",
    style: {
      transformOrigin: "210.265px 59.4923px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49 54.23a3.85 3.85 0 0 0-1.49 3.08c0 1.23.65 1.86 1.45 1.39a3.81 3.81 0 0 0 1.45-3.07c.04-1.23-.61-1.86-1.41-1.4Z",
    id: "elpao9lsx8gd",
    className: "animable",
    style: {
      transformOrigin: "215.451px 56.4677px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72 51.21a3.8 3.8 0 0 0-1.45 3.07c0 1.24.64 1.86 1.45 1.4a3.83 3.83 0 0 0 1.45-3.07c0-1.24-.65-1.86-1.45-1.4Z",
    id: "eliqflwxj5fhj",
    className: "animable",
    style: {
      transformOrigin: "220.72px 53.445px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-33",
    className: "animable",
    style: {
      transformOrigin: "136.592px 220.951px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9 282.08a1 1 0 0 1-.5-.14 1 1 0 0 1-.5-.87v-40.19a2.41 2.41 0 0 1 .34-1.17 2.46 2.46 0 0 1 .84-.88l12-6.94a1.27 1.27 0 0 1 1.29 0 1.4 1.4 0 0 1 .63.8l1 3.24a.48.48 0 0 0 .27.33.52.52 0 0 0 .41-.06l28.27-16.31a1.12 1.12 0 0 1 1-.11l.13.07a1.09 1.09 0 0 1 .47 1v33.65a2.59 2.59 0 0 1-1.19 2.06l-44 25.38a1 1 0 0 1-.46.14Zm12.89-49.54a.51.51 0 0 0-.27.09l-12 6.93a1.76 1.76 0 0 0-.77 1.32v40.19a.16.16 0 0 0 .08.14.18.18 0 0 0 .16 0l44-25.38a1.75 1.75 0 0 0 .76-1.32v-33.73a.37.37 0 0 0-.06-.25h-.06a.51.51 0 0 0-.22.09L73.1 236.89a1.27 1.27 0 0 1-1.92-.76l-1-3.24a.52.52 0 0 0-.22-.29.36.36 0 0 0-.17-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "79.2273px 250.895px"
    },
    id: "el3z9b1dnipwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-33",
    className: "animable",
    style: {
      transformOrigin: "84.3558px 253.928px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.19 224.39a.66.66 0 0 0-.27-.61l-1.82-1.06a.71.71 0 0 0-.69.07l-28 16.13-.75-2.51a.93.93 0 0 0-.41-.54l-1.83-1.06a.88.88 0 0 0-.9 0l-12 6.94a2.16 2.16 0 0 0-1 1.69v40.07a.69.69 0 0 0 .27.61l1.82 1.05a.71.71 0 0 0 .66-.08l43.86-25.33a2.16 2.16 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "84.3558px 253.939px"
    },
    id: "el7ybp209soeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24 235.83a.9.9 0 0 0-.88 0l-12 6.94a2 2 0 0 0-.69.73l-1.83-1.06a1.87 1.87 0 0 1 .69-.73l12-6.94a.88.88 0 0 1 .9 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "68.54px 239.073px"
    },
    id: "eldc7p8k2nkwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85 223.74a.7.7 0 0 0-.64.09l-28.27 16.31a.85.85 0 0 1-1.3-.52l-.22-.72 28-16.13a.85.85 0 0 1 .43-.13.49.49 0 0 1 .25.06Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "92.635px 231.461px"
    },
    id: "elj4oz2hxo3mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.51 285.06.1.1-1.78-1a.45.45 0 0 1-.17-.19.37.37 0 0 1 0-.11 1 1 0 0 1-.05-.32v-40.59c0-.05.09-.24.14-.36l.07-.11 1.83 1.06a1.93 1.93 0 0 0-.28 1v40.06a1.09 1.09 0 0 0 0 .18.29.29 0 0 0 0 .09v.05a.33.33 0 0 0 0 .06.34.34 0 0 0 .14.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "61.63px 263.82px"
    },
    className: "animable",
    id: "elahgovdfgyri"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.45 250.58a1 1 0 0 1-1-1v-40.19a2.54 2.54 0 0 1 1.19-2l12-6.94a1.27 1.27 0 0 1 1.3 0 1.31 1.31 0 0 1 .62.8l1 3.24a.47.47 0 0 0 .27.32.5.5 0 0 0 .42-.05l28.27-16.31a1.09 1.09 0 0 1 1-.11l.13.06a1.11 1.11 0 0 1 .46 1V223a2.61 2.61 0 0 1-1.18 2.06l-44 25.38a1 1 0 0 1-.48.14Zm12.89-49.53a.56.56 0 0 0-.27.08l-12 6.94a1.75 1.75 0 0 0-.76 1.32v40.19a.14.14 0 0 0 .08.13.15.15 0 0 0 .16 0l44-25.38a1.73 1.73 0 0 0 .77-1.32v-33.72a.39.39 0 0 0-.07-.26h-.05a.61.61 0 0 0-.23.08l-28.33 16.29a1.28 1.28 0 0 1-1.92-.76l-1-3.24a.56.56 0 0 0-.21-.3.49.49 0 0 0-.17-.05Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.782px 219.423px"
    },
    id: "el3ukpq9tr5op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-33",
    className: "animable",
    style: {
      transformOrigin: "138.924px 222.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.74 192.9a.72.72 0 0 0-.27-.62l-1.82-1a.66.66 0 0 0-.68.07l-28 16.13-.76-2.52a.91.91 0 0 0-.4-.54l-1.81-1.13a.86.86 0 0 0-.89 0l-12 6.93a2.17 2.17 0 0 0-1 1.7V252a.71.71 0 0 0 .26.62l1.82 1a.7.7 0 0 0 .67-.08l43.86-25.32a2.16 2.16 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "138.924px 222.444px"
    },
    id: "el00pfao38dkn0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.79 204.34a.87.87 0 0 0-.88 0l-12 6.93a2.11 2.11 0 0 0-.69.73l-1.85-1a2.11 2.11 0 0 1 .69-.73l12-6.93a.86.86 0 0 1 .89 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "123.08px 207.608px"
    },
    id: "eli5yx8weecx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4 192.24a.74.74 0 0 0-.64.1l-28.27 16.31a.86.86 0 0 1-1.31-.52l-.21-.72 28-16.13a.85.85 0 0 1 .43-.13.51.51 0 0 1 .25.06Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "147.185px 199.971px"
    },
    id: "elw6x4i7vkxwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06 253.56a.48.48 0 0 0 .09.11l-1.77-1a.53.53 0 0 1-.17-.19s0-.07 0-.11a1 1 0 0 1 0-.32V211.46a2.75 2.75 0 0 1 .15-.36l.06-.12 1.84 1.06a2 2 0 0 0-.29 1V253.43a.41.41 0 0 0 .09.13Z",
    style: {
      opacity: 0.15,
      transformOrigin: "116.229px 232.325px"
    },
    className: "animable",
    id: "elmc3xzhrypt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166 219.09a1 1 0 0 1-.5-.14 1 1 0 0 1-.5-.87V177.9a2.38 2.38 0 0 1 .34-1.17 2.58 2.58 0 0 1 .84-.89l12-6.93a1.25 1.25 0 0 1 1.29 0 1.3 1.3 0 0 1 .63.8l1 3.23a.49.49 0 0 0 .27.33.47.47 0 0 0 .41 0l28.22-16.4a1.14 1.14 0 0 1 1-.12l.13.07a1.12 1.12 0 0 1 .46 1v33.72a2.58 2.58 0 0 1-1.19 2L166.5 219a1 1 0 0 1-.5.09Zm12.9-49.53a.56.56 0 0 0-.27.08l-12 6.94a1.66 1.66 0 0 0-.54.57 1.6 1.6 0 0 0-.22.75v40.18a.16.16 0 0 0 .07.14.15.15 0 0 0 .16 0l44-25.38a1.73 1.73 0 0 0 .76-1.32V157.8a.39.39 0 0 0-.06-.26h-.05a.89.89 0 0 0-.23.09l-28.27 16.31a1.28 1.28 0 0 1-1.92-.76l-1-3.24a.5.5 0 0 0-.22-.3.45.45 0 0 0-.22-.08Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "188.297px 187.889px"
    },
    id: "el3wwmfy9xu1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "193.446px 190.916px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.28 161.41a.69.69 0 0 0-.27-.62l-1.82-1.05a.68.68 0 0 0-.69.07l-28 16.12-.75-2.51a.92.92 0 0 0-.41-.54l-1.84-1.06a.87.87 0 0 0-.89 0l-12 6.93a2.16 2.16 0 0 0-1 1.69v40.07a.72.72 0 0 0 .27.62l1.82 1a.68.68 0 0 0 .66-.08l43.87-25.32a2.18 2.18 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "193.446px 190.929px"
    },
    id: "elac6ssrbf3ns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33 172.85a.85.85 0 0 0-.87 0l-12 6.93a2.21 2.21 0 0 0-.69.73l-1.83-1.06a2 2 0 0 1 .69-.73l12-6.93a.91.91 0 0 1 .9 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "177.635px 176.09px"
    },
    id: "elvos4nhhm4z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.94 160.75a.74.74 0 0 0-.64.1l-28.3 16.3a.84.84 0 0 1-1.3-.51l-.22-.73 28-16.12a.9.9 0 0 1 .44-.14.52.52 0 0 1 .25.07Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "201.71px 168.475px"
    },
    id: "el2nrqc31llmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.6 222.07.1.11-1.78-1a.63.63 0 0 1-.17-.19.25.25 0 0 1 0-.11.8.8 0 0 1-.05-.32v-40.11a.41.41 0 0 1 0-.11 1.87 1.87 0 0 1 0-.25v-.12a2.75 2.75 0 0 1 .15-.36l.06-.12 1.83 1.06a2 2 0 0 0-.28 1v40.07a.91.91 0 0 0 0 .17V222a.39.39 0 0 0 .14.07Z",
    style: {
      opacity: 0.15,
      transformOrigin: "170.718px 200.835px"
    },
    className: "animable",
    id: "el2fcxvflxevx"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folders--inject-33",
    className: "animable",
    style: {
      transformOrigin: "136.592px 156.646px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9 217.79a1 1 0 0 1-.5-.13 1 1 0 0 1-.5-.87V176.6a2.41 2.41 0 0 1 .34-1.17 2.46 2.46 0 0 1 .84-.88l12-6.94a1.27 1.27 0 0 1 1.29 0 1.4 1.4 0 0 1 .63.8l1 3.24a.48.48 0 0 0 .27.33.48.48 0 0 0 .41-.06l28.27-16.31a1.1 1.1 0 0 1 1-.11l.12.07a1.09 1.09 0 0 1 .47 1v33.72a2.59 2.59 0 0 1-1.19 2.06l-44 25.38a1 1 0 0 1-.45.06Zm12.89-49.53a.54.54 0 0 0-.27.09l-12 6.93a1.76 1.76 0 0 0-.77 1.32v40.19a.13.13 0 0 0 .08.13.15.15 0 0 0 .16 0l44-25.38a1.75 1.75 0 0 0 .76-1.32V156.5a.4.4 0 0 0-.06-.25h-.06a.56.56 0 0 0-.23.09l-28.3 16.27a1.27 1.27 0 0 1-1.92-.76l-1-3.24a.48.48 0 0 0-.22-.29.36.36 0 0 0-.17-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "79.2223px 186.611px"
    },
    id: "el15ferk6kkz2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "84.3558px 189.623px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.19 160.11a.66.66 0 0 0-.27-.61l-1.82-1.06a.71.71 0 0 0-.69.07l-28 16.13-.75-2.51a.93.93 0 0 0-.41-.54l-1.83-1.06a.88.88 0 0 0-.9 0l-12 6.94a2.16 2.16 0 0 0-1 1.69v40.07a.69.69 0 0 0 .27.61l1.82 1a.71.71 0 0 0 .66-.08l43.86-25.33a2.16 2.16 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "84.3558px 189.634px"
    },
    id: "el4avkle9hf6x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24 171.55a.9.9 0 0 0-.88 0l-12 6.94a2 2 0 0 0-.69.73l-1.83-1.06a1.87 1.87 0 0 1 .69-.73l12-6.94a.88.88 0 0 1 .9 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "68.54px 174.793px"
    },
    id: "el4nb97j40a7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85 159.46a.7.7 0 0 0-.64.09l-28.27 16.31a.85.85 0 0 1-1.3-.52l-.22-.72 28-16.13a.85.85 0 0 1 .43-.13.49.49 0 0 1 .25.06Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "92.635px 167.181px"
    },
    id: "el0rz6c936n1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.51 220.78.1.1-1.78-1a.45.45 0 0 1-.17-.19.37.37 0 0 1 0-.11 1 1 0 0 1-.05-.32v-40.63c0-.05.09-.24.14-.36l.07-.11 1.83 1.06a1.93 1.93 0 0 0-.28 1v40.06a1.09 1.09 0 0 0 0 .18.29.29 0 0 0 0 .09.33.33 0 0 0 0 .06.34.34 0 0 0 .14.17Z",
    style: {
      opacity: 0.15,
      transformOrigin: "61.63px 199.52px"
    },
    className: "animable",
    id: "elgc657ilitx6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.45 186.3a1 1 0 0 1-1-1v-40.19a2.54 2.54 0 0 1 1.19-2.05l12-6.94a1.29 1.29 0 0 1 1.3 0 1.31 1.31 0 0 1 .62.8l1 3.24a.47.47 0 0 0 .27.32.5.5 0 0 0 .42-.05l28.27-16.31a1.12 1.12 0 0 1 1-.12l.13.07a1.11 1.11 0 0 1 .46 1v33.72a2.61 2.61 0 0 1-1.18 2.06l-44 25.38a1 1 0 0 1-.48.07Zm12.89-49.53a.56.56 0 0 0-.27.08l-12 6.94a1.75 1.75 0 0 0-.76 1.32v40.18a.16.16 0 0 0 .24.14l44-25.38a1.73 1.73 0 0 0 .77-1.32V125a.39.39 0 0 0-.07-.26h-.05a.61.61 0 0 0-.23.08l-28.27 16.31a1.28 1.28 0 0 1-1.92-.76l-1-3.24a.49.49 0 0 0-.21-.3.49.49 0 0 0-.23-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "133.782px 155.119px"
    },
    id: "eljxfeojnzgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "138.933px 158.15px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.74 128.62a.72.72 0 0 0-.27-.62l-1.82-1a.66.66 0 0 0-.68.07l-28 16.13-.76-2.52a.91.91 0 0 0-.4-.54L129 139a.86.86 0 0 0-.89 0l-12 6.93a2.17 2.17 0 0 0-1 1.7v40.06a.71.71 0 0 0 .26.62l1.82 1a.7.7 0 0 0 .67-.08l43.9-25.23a2.16 2.16 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "138.933px 158.149px"
    },
    id: "elbf8t9cw9eyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.79 140.06a.87.87 0 0 0-.88 0l-12 6.93a2.11 2.11 0 0 0-.69.73l-1.84-1.06a2.11 2.11 0 0 1 .69-.73l12-6.93a.86.86 0 0 1 .89 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "123.085px 143.298px"
    },
    id: "elrkbuj94dq4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4 128a.74.74 0 0 0-.64.1l-28.27 16.31a.86.86 0 0 1-1.31-.52l-.21-.72 28-16.13a.85.85 0 0 1 .43-.13.51.51 0 0 1 .25.06Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "147.185px 135.731px"
    },
    id: "elphe67e7umec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06 189.28a.48.48 0 0 0 .09.11l-1.77-1a.53.53 0 0 1-.17-.19s0-.07 0-.11a1 1 0 0 1 0-.32V147.18a2.75 2.75 0 0 1 .15-.36l.06-.12 1.84 1.06a2 2 0 0 0-.29 1V189.2a.41.41 0 0 0 .09.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "116.229px 168.045px"
    },
    className: "animable",
    id: "eltzxqwj3axen"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166 154.81a1 1 0 0 1-.5-.14 1 1 0 0 1-.5-.87v-40.18a2.38 2.38 0 0 1 .34-1.17 2.58 2.58 0 0 1 .84-.89l12-6.93a1.25 1.25 0 0 1 1.29 0 1.3 1.3 0 0 1 .63.8l1 3.23a.49.49 0 0 0 .27.33.47.47 0 0 0 .41 0L210 92.59a1.14 1.14 0 0 1 1-.12l.13.07a1.12 1.12 0 0 1 .46 1v33.72a2.58 2.58 0 0 1-1.19 2l-44 25.38a1 1 0 0 1-.4.17Zm12.9-49.53a.56.56 0 0 0-.27.08l-12 6.94a1.66 1.66 0 0 0-.54.57 1.6 1.6 0 0 0-.22.75v40.18a.16.16 0 0 0 .07.14.15.15 0 0 0 .16 0l44-25.38a1.73 1.73 0 0 0 .76-1.32V93.52a.41.41 0 0 0-.06-.26h-.05a.43.43 0 0 0-.23.08l-28.27 16.31a1.28 1.28 0 0 1-1.92-.76l-1-3.24a.5.5 0 0 0-.22-.3.45.45 0 0 0-.22-.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "188.297px 123.608px"
    },
    id: "elns9slee3yuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "193.446px 126.661px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.28 97.13a.69.69 0 0 0-.27-.62l-1.82-1a.68.68 0 0 0-.69.07l-28 16.12-.75-2.51a.92.92 0 0 0-.41-.54l-1.84-1.06a.87.87 0 0 0-.89 0l-12 6.93a2.16 2.16 0 0 0-1 1.69v40.07a.72.72 0 0 0 .27.62l1.82 1a.68.68 0 0 0 .66-.08l43.87-25.32a2.18 2.18 0 0 0 1-1.69Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "193.446px 126.699px"
    },
    id: "ell79391lhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33 108.57a.85.85 0 0 0-.87 0l-12 6.93a2.21 2.21 0 0 0-.69.73l-1.83-1.06a2 2 0 0 1 .69-.73l12-6.93a.91.91 0 0 1 .9 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "177.635px 111.81px"
    },
    id: "el8rm4qsqdsbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.94 96.47a.74.74 0 0 0-.64.1l-28.3 16.3a.84.84 0 0 1-1.3-.51l-.22-.73 28-16.12a.9.9 0 0 1 .44-.14.52.52 0 0 1 .25.07Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "201.71px 104.195px"
    },
    id: "elk4zjkcx9gfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.6 157.79.1.11-1.78-1a.63.63 0 0 1-.17-.19.25.25 0 0 1 0-.11.8.8 0 0 1-.05-.32v-40.11a.41.41 0 0 1 0-.11 1.87 1.87 0 0 1 0-.25v-.12a2.75 2.75 0 0 1 .15-.36l.06-.12 1.83 1.06a2 2 0 0 0-.28 1v40.03a.91.91 0 0 0 0 .17v.1a.43.43 0 0 1 0 .05v.06a.39.39 0 0 0 .14.11Z",
    style: {
      opacity: 0.15,
      transformOrigin: "170.718px 136.555px"
    },
    className: "animable",
    id: "elalpsym8bdmc"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "221.697px 269.077px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "221.697px 269.077px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "222.37px 354.295px"
    },
    id: "eloblb5qjfp4i",
    className: "animable",
    d: "m135.89 410.88-11.53-6.65 184.49-106.52 11.53 6.66-184.49 106.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      transformOrigin: "222.37px 354.295px"
    },
    className: "animable",
    d: "m135.89 410.88-11.53-6.65 184.49-106.52 11.53 6.66-184.49 106.51z",
    id: "elui91sm00ek"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.53 293a8.28 8.28 0 0 1-3.77 7.08L140.9 394.67l-4.14 2.39-11.28 6.51a9.42 9.42 0 0 1-1.45-4.06l-11.18-165.7a11.72 11.72 0 0 1 0-1.45v-1.05a3.91 3.91 0 0 1 .07-.39 7.54 7.54 0 0 1 .17-.75l.06-.22c0-.09.05-.18.08-.26s.13-.33.15-.4a2.71 2.71 0 0 1 1-1.31c1.07-.62 2.21-3.21 2.57-5.8l1.38-9.93a10.93 10.93 0 0 1 4.75-7.05l53.31-30.77a3.72 3.72 0 0 1 5.61 2.11l2 5.89a3.73 3.73 0 0 0 5.62 2.12l103.27-59.61c2.26-1.32 4.24-.26 4.42 2.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "210.679px 263.971px"
    },
    id: "elypszz854mt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.53 293a8.28 8.28 0 0 1-3.77 7.08L140.9 394.67l-4.14 2.39-11.28 6.51a9.42 9.42 0 0 1-1.45-4.06l-11.18-165.7a11.72 11.72 0 0 1 0-1.45v-1.05a3.91 3.91 0 0 1 .07-.39 7.54 7.54 0 0 1 .17-.75l.06-.22c0-.09.05-.18.08-.26s.13-.33.15-.4a2.71 2.71 0 0 1 1-1.31c1.07-.62 2.21-3.21 2.57-5.8l1.38-9.93a10.93 10.93 0 0 1 4.75-7.05l53.31-30.77a3.72 3.72 0 0 1 5.61 2.11l2 5.89a3.73 3.73 0 0 0 5.62 2.12l103.27-59.61c2.26-1.32 4.24-.26 4.42 2.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "210.679px 263.971px"
    },
    className: "animable",
    id: "elz5gbx1z7k3j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87 124.62a2.79 2.79 0 0 0-2.41 0l-.27.12-.26.15-103.27 59.66a3.94 3.94 0 0 1-.87.39l-.37.11h-.12a3.65 3.65 0 0 1-4.06-2.2 4.43 4.43 0 0 0 1.57-.53l103.28-59.63a3 3 0 0 1 3-.25c.44.24 3.23 1.86 3.78 2.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "240.055px 153.633px"
    },
    id: "el4ffonx79bbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87 124.62a2.79 2.79 0 0 0-2.41 0l-.27.12-.26.15-103.27 59.66a3.94 3.94 0 0 1-.87.39l-.37.11h-.12a3.65 3.65 0 0 1-4.06-2.2 4.43 4.43 0 0 0 1.57-.53l103.28-59.63a3 3 0 0 1 3-.25c.44.24 3.23 1.86 3.78 2.18Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "240.055px 153.633px"
    },
    className: "animable",
    id: "el4w7jiuttzfm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45 172.1a3.76 3.76 0 0 0-3.84.11L119.3 203a10.1 10.1 0 0 0-3.31 3.43l3.84 2.22a10.31 10.31 0 0 1 3.32-3.43l53.31-30.77a.2.2 0 0 1 .08 0 3.74 3.74 0 0 1 3.78-.07c-.22-.19-3.26-1.92-3.87-2.28Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "148.155px 190.138px"
    },
    id: "el302rt7blols",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45 172.1a3.76 3.76 0 0 0-3.84.11L119.3 203a10.1 10.1 0 0 0-3.31 3.43l3.84 2.22a10.31 10.31 0 0 1 3.32-3.43l53.31-30.77a.2.2 0 0 1 .08 0 3.74 3.74 0 0 1 3.78-.07c-.22-.19-3.26-1.92-3.87-2.28Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "148.155px 190.138px"
    },
    className: "animable",
    id: "elbv0e1v70cn8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.56 210-1.38 10c-.36 2.59-1.51 5.19-2.57 5.79a2.73 2.73 0 0 0-1 1.32l3.84 2.22s.14-.28.18-.38l.12-.2a1.94 1.94 0 0 1 .68-.73c1.07-.62 2.21-3.21 2.57-5.8l1.38-9.93a9.84 9.84 0 0 1 1.43-3.62l-3.81-2.26a9.72 9.72 0 0 0-1.44 3.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "114.71px 217.87px"
    },
    id: "elh6wjbcxsjgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.56 210-1.38 10c-.36 2.59-1.51 5.19-2.57 5.79a2.73 2.73 0 0 0-1 1.32l3.84 2.22s.14-.28.18-.38l.12-.2a1.94 1.94 0 0 1 .68-.73c1.07-.62 2.21-3.21 2.57-5.8l1.38-9.93a9.84 9.84 0 0 1 1.43-3.62l-3.81-2.26a9.72 9.72 0 0 0-1.44 3.59Z",
    style: {
      opacity: 0.15,
      transformOrigin: "114.71px 217.87px"
    },
    className: "animable",
    id: "eldmmt8gd137d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.49 138a3.06 3.06 0 0 0-1.37-2.61l-3.84-2.22a3 3 0 0 0-3 .25L124.93 235.24a8.33 8.33 0 0 0-3.78 7.09l10.32 152.88a3.08 3.08 0 0 0 1.35 2.6l3.86 2.23a3 3 0 0 0 3-.25L316 298a8.3 8.3 0 0 0 3.78-7.09Z",
    style: {
      fill: "#fff",
      transformOrigin: "220.465px 266.605px"
    },
    id: "elmnur3qjgpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.68 400-3.86-2.23a3.1 3.1 0 0 1-1.35-2.6l-10.32-152.84a7.4 7.4 0 0 1 .72-3.47l3.83 2.22a7.31 7.31 0 0 0-.7 3.46l10.31 152.89a3.06 3.06 0 0 0 1.37 2.57Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "128.912px 319.43px"
    },
    id: "el9vfcfxzi045",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.78 237.46 176.29-101.79c2.27-1.3 4.24-.25 4.42 2.36l10.32 152.88A8.3 8.3 0 0 1 316 298L139.73 399.79c-2.26 1.3-4.24.25-4.41-2.36L125 244.54a8.27 8.27 0 0 1 3.78-7.08Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "222.405px 267.73px"
    },
    id: "el0gv6fjtygzdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.05 250.07-9.86 156.09c-.17 2.61-2.14 3.66-4.4 2.36l-3.34-1.93a9.9 9.9 0 0 1-4.45-7.09l-11.15-165.7a10.43 10.43 0 0 1 .63-4.51l-3.85-2.22a10.46 10.46 0 0 0-.62 4.52L120.5 401.9a10 10 0 0 0 4.42 7.09l10.44 6c2.27 1.3 4.23.25 4.4-2.36l10.14-160.34a7.19 7.19 0 0 1 .35-1.78l-3.84-2.21a7.23 7.23 0 0 0-.36 1.77Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "129.612px 321.309px"
    },
    id: "elj6o5qexatlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.05 250.07-9.86 156.09c-.17 2.61-2.14 3.66-4.4 2.36l-3.34-1.93a9.9 9.9 0 0 1-4.45-7.09l-11.15-165.7a10.43 10.43 0 0 1 .63-4.51l-3.85-2.22a10.46 10.46 0 0 0-.62 4.52L120.5 401.9a10 10 0 0 0 4.42 7.09l10.44 6c2.27 1.3 4.23.25 4.4-2.36l10.14-160.34a7.19 7.19 0 0 1 .35-1.78l-3.84-2.21a7.23 7.23 0 0 0-.36 1.77Z",
    style: {
      opacity: 0.25,
      transformOrigin: "129.612px 321.309px"
    },
    className: "animable",
    id: "eli6q1mwbd7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24 142.73a2.86 2.86 0 0 0-2.62.38h-.05L154.29 245.19a10 10 0 0 0-4 5.33l-3.85-2.22a10.07 10.07 0 0 1 4-5.33l176.33-102.06a2.77 2.77 0 0 1 2.77-.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.84px 195.439px"
    },
    id: "elagp7hhvmuhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24 142.73a2.86 2.86 0 0 0-2.62.38h-.05L154.29 245.19a10 10 0 0 0-4 5.33l-3.85-2.22a10.07 10.07 0 0 1 4-5.33l176.33-102.06a2.77 2.77 0 0 1 2.77-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "239.84px 195.439px"
    },
    className: "animable",
    id: "elr4w45rjbehb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29 245.19a9.92 9.92 0 0 0-4.4 7.1l-10.14 160.44c-.18 2.37-1.87 3.42-3.9 2.53a8.6 8.6 0 0 0 3.69.74 8.38 8.38 0 0 0 4-.95l176.32-101.82a9.85 9.85 0 0 0 4.39-7.09l10.16-160.66c.16-2.61-1.53-3.67-3.79-2.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "235.135px 279.28px"
    },
    id: "elv87zkmrlunh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-33",
    className: "animable",
    style: {
      transformOrigin: "75.695px 319.956px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-33",
    className: "animable",
    style: {
      transformOrigin: "75.695px 319.956px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-33",
    className: "animable",
    style: {
      transformOrigin: "74.3852px 353.905px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "74.3852px 353.905px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.91 381.29c-8.82-9.1-14-46.12-5.4-53.33h43.75c8.6 7.21 3.42 44.22-5.39 53.32l-.24.25-.3.3c-.25.24-.51.48-.8.71l-.21.17-.66.51c-.38.27-.76.52-1.14.74-7.25 4.23-19 4.23-26.26 0a11.29 11.29 0 0 1-1.15-.75c-.22-.15-.42-.31-.62-.47l-.26-.21a10.21 10.21 0 0 1-.77-.69l-.35-.34Z",
    style: {
      fill: "#37474f",
      transformOrigin: "74.3852px 357.546px"
    },
    id: "el4qjw5fqxv0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46 325.05c10 5.83 10 15.28 0 21.11s-26.17 5.82-36.15 0-10-15.28 0-21.11 26.17-5.83 36.15 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "74.3887px 335.603px"
    },
    id: "el8n535ml7vzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.66 327.85c7.33 4.28 7.33 11.22 0 15.5s-19.22 4.28-26.55 0-7.33-11.22 0-15.5 19.22-4.28 26.55 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "74.385px 335.6px"
    },
    id: "elq0605e6odd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11 335.21c7.33-4.28 19.22-4.28 26.55 0a12.2 12.2 0 0 1 4.39 4.07 12.12 12.12 0 0 1-4.39 4.07c-7.33 4.28-19.22 4.28-26.55 0a12.28 12.28 0 0 1-4.39-4.07 12.37 12.37 0 0 1 4.39-4.07Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "74.385px 339.28px"
    },
    id: "ely7namjrsm1k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-33",
    className: "animable",
    style: {
      transformOrigin: "75.695px 297.17px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.67 268.86 14.57 11.55-14.09-6.5a38.9 38.9 0 0 0 2.45 13.34 86.32 86.32 0 0 1 11 7.78l-10.8-4.27s-.73 7.12 2.23 18c.77 2.85 4 8.27 6 12.33a46.37 46.37 0 0 0 3.14 5.42l.22.33c2.47-1.41 5-2.79 7.69-4.11 1.74-3.65 4-12.67 4.82-20.05 3.11-28.27-18.26-44.47-35.45-49.9a51.16 51.16 0 0 1 8.22 16.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "66.3271px 289.81px"
    },
    id: "eljom7cssvbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.67 268.86 14.57 11.55-14.09-6.5a38.9 38.9 0 0 0 2.45 13.34 86.32 86.32 0 0 1 11 7.78l-10.8-4.27s-.73 7.12 2.23 18c.77 2.85 4 8.27 6 12.33a46.37 46.37 0 0 0 3.14 5.42l.22.33c2.47-1.41 5-2.79 7.69-4.11 1.74-3.65 4-12.67 4.82-20.05 3.11-28.27-18.26-44.47-35.45-49.9a51.16 51.16 0 0 1 8.22 16.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "66.3271px 289.81px"
    },
    className: "animable",
    id: "elpxjhqg74o7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.85 270c3 3 4.71 6.93 6.05 10.86a57.52 57.52 0 0 1 2.58 12.23 52.89 52.89 0 0 1-3.08 24.54.41.41 0 1 0 .76.3 53.49 53.49 0 0 0 2.73-24.88 57.59 57.59 0 0 0-2.8-12.25c-1.4-3.89-3.22-7.8-6.24-10.8Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "73.5849px 294.111px"
    },
    id: "eltn4xn27ivd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72 283.68a216.88 216.88 0 0 0-15.22 21.39l-14.8 2.4 10.9 1.9-5.86 9.27-14.54 3 11.36 1.85s-3.16 11.08-11.29 15.7c-4.48 2.55-6.68 2.94-8 1.66-.94-.89-1.16-6.21-1.94-11s-.85-12.46 3.63-21.76a29.07 29.07 0 0 1 4.65-6.85c10.73-11.93 31.06-17.7 41.11-17.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "94.8217px 312.619px"
    },
    id: "elktd1yossu4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72 283.68a216.88 216.88 0 0 0-15.22 21.39l-14.8 2.4 10.9 1.9-5.86 9.27-14.54 3 11.36 1.85s-3.16 11.08-11.29 15.7c-4.48 2.55-6.68 2.94-8 1.66-.94-.89-1.16-6.21-1.94-11s-.85-12.46 3.63-21.76a29.07 29.07 0 0 1 4.65-6.85c10.73-11.93 31.06-17.7 41.11-17.56Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "94.8217px 312.619px"
    },
    className: "animable",
    id: "el6v5ik9u4nxt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26 288.52a60 60 0 0 0-20.56 14.2 40.25 40.25 0 0 0-7 10.45 38.44 38.44 0 0 0-3.22 12.14h.09a49.32 49.32 0 0 1 3.87-11.8 45.24 45.24 0 0 1 6.79-10.37 61.51 61.51 0 0 1 20.1-14.56v-.07Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "88.905px 306.91px"
    },
    id: "el4txvcxsv4vt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67 289.79a29 29 0 0 1 3.71.17 59.18 59.18 0 0 1 14.23 3.46c1.7.63 3.4 1.35 5.08 2.15q1.26.6 2.49 1.26a41.36 41.36 0 0 1 10.9 8.24 26.13 26.13 0 0 1 3.75 5.28c.13.24.27.48.4.73.32.65.6 1.29.87 1.92a35.54 35.54 0 0 1 3.21 17.5c-.15 4.24-1.6 9.09-2.42 9.89a2.51 2.51 0 0 1-.37.27c-1.21.77-3.13.32-6.73-1.69-7.2-4-10-14.23-10-14.23l10-1.7-12.85-2.57-5.22-8.14 9.61-1.75-13.06-2a193.74 193.74 0 0 0-13.58-18.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "54.0355px 315.4px"
    },
    id: "el61hnyfln5mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67 289.79a29 29 0 0 1 3.71.17 59.18 59.18 0 0 1 14.23 3.46c1.7.63 3.4 1.35 5.08 2.15q1.26.6 2.49 1.26a41.36 41.36 0 0 1 10.9 8.24 26.13 26.13 0 0 1 3.75 5.28c.13.24.27.48.4.73.32.65.6 1.29.87 1.92a35.54 35.54 0 0 1 3.21 17.5c-.15 4.24-1.6 9.09-2.42 9.89a2.51 2.51 0 0 1-.37.27c-1.21.77-3.13.32-6.73-1.69-7.2-4-10-14.23-10-14.23l10-1.7-12.85-2.57-5.22-8.14 9.61-1.75-13.06-2a193.74 193.74 0 0 0-13.58-18.78Z",
    style: {
      fill: "#fff",
      opacity: 0.65,
      transformOrigin: "54.0355px 315.4px"
    },
    className: "animable",
    id: "el88df97kh452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.38 290a59.18 59.18 0 0 1 14.23 3.46c1.7.63 3.4 1.35 5.08 2.15q1.26.6 2.49 1.26a41.36 41.36 0 0 1 10.9 8.24 26.13 26.13 0 0 1 3.75 5.28c.13.24.27.48.4.73.32.65.6 1.29.87 1.92a35.54 35.54 0 0 1 3.21 17.5c-.15 4.24-1.6 9.09-2.42 9.89a2.51 2.51 0 0 1-.37.27 2.08 2.08 0 0 1-.79.29c.88-6.57-2.35-23.25-7.25-30.11-5.09-7.13-17.18-17.48-33.79-21.05a28.45 28.45 0 0 1 3.69.17Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "54.0455px 315.407px"
    },
    className: "animable",
    id: "el5549wm1klil"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.77 341a56.35 56.35 0 0 0-1-14.54A46.86 46.86 0 0 0 67 312.63a40.69 40.69 0 0 0-9.77-10.9 54.05 54.05 0 0 0-12.52-7.51h-.06v.05a72.19 72.19 0 0 1 12 8.07 53.6 53.6 0 0 1 5.35 4.95 31 31 0 0 1 4.43 5.71 46.33 46.33 0 0 1 5 13.54A56.17 56.17 0 0 1 72.69 341s.08 0 .08 0Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "58.7624px 317.61px"
    },
    id: "elceg28yjdk6",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33",
    className: "animable",
    style: {
      transformOrigin: "399.831px 230.925px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-33",
    className: "animable",
    style: {
      transformOrigin: "399.831px 230.925px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-33",
    className: "animable",
    style: {
      transformOrigin: "402.105px 132.515px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.89 130.53c-7.17-.57-11.11-2.55-15.41 5.56-4.43 8.36-13.81 28.21-16.86 34.38.68 3.72 9.24 8.41 13.16 7.32s15.81-27.69 15.81-27.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "383.755px 153.925px"
    },
    id: "eln62sd3ibhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89 130.53c-7.69-.54-11.11-2.55-15.41 5.56-4.43 8.36-13.81 28.21-16.86 34.38.68 3.72 9.24 8.41 13.16 7.32s15.81-27.69 15.81-27.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "383.755px 153.932px"
    },
    className: "animable",
    id: "elhglyra94tau"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81 132.31a72.52 72.52 0 0 0-13.7-2.82 62 62 0 0 0-15.39 1 40 40 0 0 0-9.93 9.2c-5.26 6.66-6.9 9.52-6.9 15.39 0 4.21 4 7.93 4 7.93.31 4.14.21 9.13.16 11.75-.07 2.93-.36 4.09 1.28 5.34 4.73 5.95 31.53 6.72 40.84-.74a3.3 3.3 0 0 0 1.92-2.87c.42-2.86 1.16-6.35 1.43-7.7 1.26-6.16 3.33-12.63 4.35-17 3.13-13.29-5.73-18.67-8.06-19.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "409.211px 157.069px"
    },
    id: "el7wyzq6eymm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.81 132.31a72.52 72.52 0 0 0-13.7-2.82 62 62 0 0 0-15.39 1 40 40 0 0 0-9.93 9.2c-5.26 6.66-6.9 9.52-6.9 15.39 0 4.21 4 7.93 4 7.93.31 4.14.21 9.13.16 11.75-.07 2.93-.36 4.09 1.28 5.34 4.73 5.95 31.53 6.72 40.84-.74a3.3 3.3 0 0 0 1.92-2.87c.42-2.86 1.16-6.35 1.43-7.7 1.26-6.16 3.33-12.63 4.35-17 3.13-13.29-5.73-18.67-8.06-19.48Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "409.211px 157.069px"
    },
    className: "animable",
    id: "elmrryvc782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84 81.14c-1.53.67-2.77 1.67-4.51 1.8a2.3 2.3 0 0 1-1.48-.31 1 1 0 0 1-.27-1.35 5.2 5.2 0 0 0-1.6 1.26 1.82 1.82 0 0 0-.28 1.91 7.38 7.38 0 0 0-5.07 1.14 3 3 0 0 0-1.33 1.53c-.49 1.56 1.05 3.41.15 4.77-.65 1-2.09.93-3.19 1.37a3.51 3.51 0 0 0-2.12 3.74 9.9 9.9 0 0 0 .85 2.25 10 10 0 0 1 .71 2.61 2.84 2.84 0 0 1-.45 2.2 1.25 1.25 0 0 1-2 0 2.28 2.28 0 0 0 1.94 2.62 2.57 2.57 0 0 0-1.46 1.81 2.94 2.94 0 0 0 .71 2.43 10.34 10.34 0 0 0 .82.69c.78.82-.07 2.14-.19 3a2.74 2.74 0 0 0 .28 1.69 3.37 3.37 0 0 0 1.56 1.22 2.37 2.37 0 0 1 1.11.82 3.16 3.16 0 0 1 .21.68 4.34 4.34 0 0 0 3.71 3.21 12 12 0 0 0 2.38-.15 14.68 14.68 0 0 1 4.39 0 17.84 17.84 0 0 0 4.95.5c1.23-.07 2.46-.22 3.7-.23a23.17 23.17 0 0 1 3.53.44c.78.11 1.33 0 2 .45s1.34 1.54 2.14 2.16a4 4 0 0 0 3.06.76 20.23 20.23 0 0 1 2.9-.74c1.31 0 2.57.87 3.83.54 1.91-.51 2.33-3.36 4.2-4 .86-.29 1.86 0 2.69-.41A2.36 2.36 0 0 0 433 120a4.86 4.86 0 0 0 0-2 2.18 2.18 0 0 0 2.91.21 1 1 0 0 1-1-.91 2.28 2.28 0 0 1 .48-1.4 4.74 4.74 0 0 0 .74-1.31c.43-1.49-1-2.36-1.08-3.68-.07-1.11 1-2 1.35-3a2.84 2.84 0 0 0-.35-2.69c-.6-.83-1.68-1.37-1.87-2.37s.45-1.73.7-2.61a3.38 3.38 0 0 0-.8-3.11 7 7 0 0 0-1.21-.9c-.36-.26-.95-1-1.47-.89a1.65 1.65 0 0 0 1.22-2.26 1.32 1.32 0 0 1-1.57.11 2.49 2.49 0 0 1-1-1.33 17.71 17.71 0 0 0-1.45-3.73 6.18 6.18 0 0 0-3.45-2.58c-3-1-4.82-.61-7.68.27-1-3-3.94-4.34-6.93-5.19a9.92 9.92 0 0 0-6.7.51Z",
    style: {
      fill: "#263238",
      transformOrigin: "409.906px 103.242px"
    },
    id: "elnyxof1hkd59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.55 122.65c.54-5.22 2.79-9.28 3.45-15.48s.89-10.86-4.88-15.7-11.9-5-14.64-4.5-5.89 3.1-5.89 3.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "410.461px 104.714px"
    },
    id: "elylrpz49w1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.22 106c-7.11-4.52-2.83-17.58 7.37-15.91 0 0 9.05-3.37 16.91 2.56a18 18 0 0 1 4.43 4.78 16.82 16.82 0 0 1 2 12.84l-1.07 4.52-.24 6.89Z",
    style: {
      fill: "#263238",
      transformOrigin: "404.062px 105.408px"
    },
    id: "elt6zed8m8lon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.77 93.58a7.16 7.16 0 0 0-3.69 4.76c-.71 2.85-1.12 7.47-.75 14.36.47 8.75 3.79 13.12 8 13.6a31.78 31.78 0 0 0 5.49 0l.09 4.69s-6.24 5.75-4.26 17.3c14.87-10.85 20.09-17.77 20.09-17.77l.06-15.8c.62 1 3.7 2.4 6.11-.69 2.84-3.63 2.21-8-.32-9.55s-5.61-.08-6.77 2.88c-2.72 1.13-18.66-.78-18.41-13.9a6.38 6.38 0 0 0-5.64.12Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "408.985px 120.576px"
    },
    id: "eligz3cwncipj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43 112.7a1.44 1.44 0 1 1-1.63-1.21 1.45 1.45 0 0 1 1.63 1.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.006px 112.916px"
    },
    id: "ely1kdsl11qw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85 126.35c8.42-1.82 13.15-5.23 14-8.64 0 0-.53 4.45-2.9 6.42-3.31 2.76-11.06 4.55-11.06 4.55Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "410.85px 123.195px"
    },
    id: "elj3b31sy1yba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.4 117.54 5.87-2.16a3 3 0 0 1-1.73 4 3.3 3.3 0 0 1-4.14-1.84Z",
    style: {
      fill: "#b16668",
      transformOrigin: "402.456px 117.474px"
    },
    id: "elcrl3mkh0gqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.2 119.54a3.25 3.25 0 0 0 1.34-.18 3 3 0 0 0 1.94-2.52 3.61 3.61 0 0 0-3.28 2.7Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "403.84px 118.195px"
    },
    id: "el4ac4cmxsavu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.95,
    cy: 106.57,
    rx: 1.62,
    ry: 1.61,
    style: {
      fill: "#263238",
      transformOrigin: "405.95px 106.57px"
    },
    id: "els446qpbxbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.66,
    cy: 106.5,
    rx: 1.62,
    ry: 1.61,
    style: {
      fill: "#263238",
      transformOrigin: "394.66px 106.5px"
    },
    id: "elcxg222kgtoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f",
      transformOrigin: "398.715px 109.02px"
    },
    id: "el5py2dmscf06",
    className: "animable",
    d: "m401.83 103.71-.85 10.62-5.38-1.9 6.23-8.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 103.84 3.71-1.28a1.89 1.89 0 0 0-2.44-1.24 2 2 0 0 0-1.27 2.52Z",
    style: {
      fill: "#263238",
      transformOrigin: "393.805px 102.526px"
    },
    id: "elus92p26ej2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.4 104-3.65-1.57a1.91 1.91 0 0 1 2.56-1.07 2.05 2.05 0 0 1 1.09 2.64Z",
    style: {
      fill: "#263238",
      transformOrigin: "406.648px 102.598px"
    },
    id: "elt1op5muqidg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-33",
    className: "animable",
    style: {
      transformOrigin: "405.899px 280.479px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.7 339.4c.34 2.1 1 4.55 1.54 8.85s-.41 4.46 2.18 15.27c1.55 6.49 1.19 9.05-2.87 14.41-4.34 5.73-8.72 4.46-11.47-2.06-2.34-5.58-2.15-8.14-2-13.86s.09-7.39-.08-11.93c-.15-4 .24-6.73.05-9.8Z",
    style: {
      fill: "#37474f",
      transformOrigin: "437.617px 360.489px"
    },
    id: "elc6w4ldhwpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68 355.1c-.68-5.56-.75-11.31-1-15.06-.47-8.4 1.58-25 .64-37.6l-21.23-2.6c.61 4.94 6 27.32 7.89 40.79 0 0 .47 18.25 1.48 26.3a1.54 1.54 0 0 0 2.13 1.24 14 14 0 0 1 9.65-.42 1.54 1.54 0 0 0 2.08-1.43c.05-2.97-1.13-7.05-1.64-11.22Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "432.706px 334.066px"
    },
    id: "elqsuw6v9kpjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.83 298.51c.08 17.48-.1 32.95-.72 37.48s-.88 6.07-2 9.24-3.11 7.39-4.85 9.44c0 0-5 5.32-3.88 5.87s11.57 1.66 16.25.24 5.18-5.38 6.78-12.63 3-17.85 3-17.85a5.31 5.31 0 0 1-.48-1.23c-.62-2.09 1.28-7.52 1.77-12.79Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "382.958px 329.992px"
    },
    id: "el4mhkber8s8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 341.13c-.31 1.69-1.77 3.61-2.42 6.25a47.2 47.2 0 0 0-1.36 9.16l-.24 4.32-1.17-.07.43-7.85c.13-2.39 0-4.16-1.14-4.48-.01 0 .22-7.64 5.9-7.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "397.05px 350.99px"
    },
    id: "elrr6h78dop1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.15 329.33c.76 2 3.3 4.81 4.39 6.72a7.29 7.29 0 0 1 .9 3.28 3.43 3.43 0 0 1-1 2.57 40.73 40.73 0 0 0-3.64 4c-1.43 1.92-4.11 6.4-4.86 9.57s-1.17 6-3.89 7.53c-2.12 1.22-10.82 2.93-15.23 3.21-6 .38-7.56-2.51-5.31-4.82s6.06-6.26 6.75-6.75a10.94 10.94 0 0 1 5.59.78c3.36 1.45 4.44 3.4 8 1.64 3.2-1.6 4.48-7.51 4.2-16-.37-9.66 4.1-11.73 4.1-11.73Z",
    style: {
      fill: "#37474f",
      transformOrigin: "382.986px 347.787px"
    },
    id: "elf4rvmfqa0b4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19 179.38c.39 2.2.83 4.25 1.62 5.35 4.78 6.72 9.66 14.85 10.47 27.32a549.69 549.69 0 0 1 .27 59.13c.21 2.66 2.22 9.11 2.5 24.28.23 12.09-.58 30.87-.58 30.87s-8.68 4.2-16.21 1.3c-3-11.54-7.86-39.28-10.78-52.49-3.07-13.92-6.2-30.52-6.2-30.52l-5.21 24.29a70.47 70.47 0 0 1-.2 15.71c-1 8.07-7.53 36.5-7.53 36.5s-9.62 2.93-16.09-1.6c0 0-.56-40.26-.56-49.14s1.72-61.66 7.31-84.86a50.33 50.33 0 0 0 .35-5.4c6.34 5.29 32.34 4.88 40.84-.74Z",
    style: {
      fill: "#37474f",
      transformOrigin: "411.391px 254.015px"
    },
    id: "el6fh8v1ggd8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.64 322.15c-3.3 3-13.39 3.75-17.34 1.63l1.2 6.28s2.6 1.78 8.34 1.29 7.58-2.77 7.58-2.77Z",
    style: {
      fill: "#455a64",
      transformOrigin: "433.97px 326.793px"
    },
    id: "elpwioacrm8hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31 317.14c-3.42 1.13-13.58.53-17.3-1.78l.15 5.39s2.1 2 7.82 2.63 8.23-1 8.23-1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "388.66px 319.442px"
    },
    id: "el0w1ijvuygr29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.28 244.62-3.74-29.77a18.79 18.79 0 0 1-15-7.25s-.25 7.45 12 10.87l4.46 27.44-2.9 23Z",
    style: {
      fill: "#263238",
      transformOrigin: "399.91px 238.255px"
    },
    id: "el9u9o8olc5lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07 185.09s6.16 4.69 20.7 4.08 21.6-5.19 21.5-5.44a20.94 20.94 0 0 1-1-3.79c0-.22-.08-.41-.1-.55-8.5 5.66-34.5 6-40.84.74 0 0-.07 3.48-.28 5Z",
    style: {
      fill: "#263238",
      transformOrigin: "408.161px 184.307px"
    },
    id: "elgaqv3nbqkjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.38 184.78c-1.67 3.48-4.16 10.76-4.35 15.77a17.35 17.35 0 0 0 7.49 1.67s1-8.77-.6-16.26Z",
    style: {
      fill: "#263238",
      transformOrigin: "417.929px 193.5px"
    },
    id: "el1rjkxgwyebl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.63 182.87c2.58 2.87 7 9.17 8.58 13.92a17.2 17.2 0 0 1-6.72 3.7s-3.42-8.13-4-15.77Z",
    style: {
      fill: "#263238",
      transformOrigin: "425.85px 191.68px"
    },
    id: "elj20vkq6e9ho",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arms--inject-33",
    className: "animable",
    style: {
      transformOrigin: "399.831px 174.935px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.52 187.93c.35-.46 1.43.5 3.72 1 2.92.65 4.06.55 7.16 1.36a15.63 15.63 0 0 0 4.32.8l-11.3 2.31a12.3 12.3 0 0 1-3.17-1.93 2.67 2.67 0 0 1-.73-3.54Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "407.93px 190.604px"
    },
    id: "elexe0oyi0ylb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.94 157.2c-.79-.34-1.36 0-1.25.72l5.31 37.74 53 22.49-5.41-37.8a2.86 2.86 0 0 0-1.63-1.94l-30.27-12.85-2.15-3.83a1.33 1.33 0 0 0-.66-.57l-12.55-5.34a1.32 1.32 0 0 0-1.73.54l-.62 1.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "378.838px 186.918px"
    },
    id: "elc25o5x4z1wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.94 157.2c-.79-.34-1.36 0-1.25.72l5.31 37.74 53 22.49-5.41-37.8a2.86 2.86 0 0 0-1.63-1.94l-30.27-12.85-2.15-3.83a1.33 1.33 0 0 0-.66-.57l-12.55-5.34a1.32 1.32 0 0 0-1.73.54l-.62 1.69Z",
    style: {
      opacity: 0.15,
      transformOrigin: "378.838px 186.918px"
    },
    className: "animable",
    id: "elwin94w0yi"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "377.065px 187.435px"
    },
    id: "ellk9vqilkgn",
    className: "animable",
    d: "m354.97 195.66 51.2 21.73-5.35-37.48-52.86-22.43 7.01 38.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 218.15-8.86-35.74a3.3 3.3 0 0 0-1.77-1.93l-50-21.21c-.8-.34-1.3 0-1.12.71l8.75 35.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "377.107px 188.644px"
    },
    id: "el34xuywuif9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3 172.49c-2.28 2.76-2.3 4.94-1.46 8.58s3.2 8 4.53 9.14 3.82 2.85 6.62 2.28 2.88-4.14 4.14-5.64c2-2.39-.7-4.16-3.3-4.51-6.14-.85-9.09-3.94-9.09-3.94Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "355.578px 182.547px"
    },
    id: "elkfm4aiomjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43 193.49a42.36 42.36 0 0 0 8-.08l11.3-2.31c5 .58 19.4-9.49 19.4-9.49a71.27 71.27 0 0 0-5.51-23.24c-4.73-6.63-5.06-18-1.8-26.06 9.39-.47 12.85 4.22 15.89 13.62 2.39 7.39 7 27.69 9 35.41 1.13 4.42 1.57 8.33-3.25 11.09a138.22 138.22 0 0 1-24.88 9.92c-5.09 1.44-7.91 2.86-13.28 3.65a46.53 46.53 0 0 1-8.74.65 12.28 12.28 0 0 1-3.1-.33 18.79 18.79 0 0 1-4.34-2.77 3 3 0 0 1-1-1.05c-.31-.62-.18-1.41-.57-2s-1-.69-1.34-1.13c-.67-.78-.59-2-1.11-2.88s-1.37-1.62-.89-2.57c.69-1.51 2.61-.73 6.22-.43Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "421.759px 169.469px"
    },
    id: "el1s5c2qz5e2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38 132.18c4.8 0 9-2.07 12.21 2.58 3.05 4.45 4.84 11.85 8.18 24.37a159.55 159.55 0 0 1 4.2 19.6s-10.75-1.07-16.85 2.88l-5.85-20.16s-5-8.58-4.71-16.28a37 37 0 0 1 2.82-12.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "438.259px 156.665px"
    },
    id: "ely8b8e3ulf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38 132.18c4.8 0 9-2.07 12.21 2.58 3.05 4.45 4.84 11.85 8.18 24.37a159.55 159.55 0 0 1 4.2 19.6s-10.75-1.07-16.85 2.88l-5.85-20.16s-5-8.58-4.71-16.28a37 37 0 0 1 2.82-12.99Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "438.259px 156.665px"
    },
    className: "animable",
    id: "elf3t7mcigikh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12 181.61s6-2 11.21-1.22 6.67 2.27 6.67 2.27.46-4.26-1.15-6.08a21.73 21.73 0 0 0-17.31 3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "443.8px 179.297px"
    },
    id: "elucjn9mn5dak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12 181.61s6-2 11.21-1.22 6.67 2.27 6.67 2.27.46-4.26-1.15-6.08a21.73 21.73 0 0 0-17.31 3Z",
    style: {
      opacity: 0.3,
      transformOrigin: "443.8px 179.297px"
    },
    className: "animable",
    id: "elpjuerq98nv"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-33",
    className: "animable animator-active",
    style: {
      transformOrigin: "272.804px 412.521px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.38 438.14-2.43-1.4a.47.47 0 1 0-.46.81l2.42 1.4a.49.49 0 0 0 .23.06.48.48 0 0 0 .41-.23.47.47 0 0 0-.17-.64Zm6.46 3.73-2.42-1.4a.47.47 0 1 0-.47.81l2.43 1.4a.46.46 0 0 0 .23.06.46.46 0 0 0 .23-.87Zm-1.67-41a.46.46 0 0 0-.64-.17l-2.42 1.4a.45.45 0 0 0-.17.63.46.46 0 0 0 .4.24.39.39 0 0 0 .23-.07l2.43-1.4a.46.46 0 0 0 .17-.66Zm14.14 35.08-2.42 1.4a.46.46 0 0 0-.17.64.47.47 0 0 0 .4.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.64.46.46 0 0 0-.64-.2Zm-1.21-42.55a.45.45 0 0 0-.63-.17L236 394.6a.47.47 0 0 0-.17.64.48.48 0 0 0 .4.23.53.53 0 0 0 .24-.06l2.42-1.4a.46.46 0 0 0 .21-.64Zm-6.46 3.73a.47.47 0 0 0-.64-.17l-2.43 1.4a.47.47 0 0 0-.17.64.48.48 0 0 0 .41.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.67Zm1.21 42.55-2.43 1.4a.47.47 0 0 0-.17.64.46.46 0 0 0 .4.23.53.53 0 0 0 .24-.06l2.42-1.4a.47.47 0 0 0-.46-.81Zm-14.15-35.11a.47.47 0 0 0-.64-.17l-2.42 1.4a.47.47 0 0 0-.17.64.45.45 0 0 0 .4.23.53.53 0 0 0 .24-.06l2.42-1.4a.46.46 0 0 0 .17-.64Zm-19.4 11.2a.47.47 0 0 0-.64-.17l-2.42 1.4a.46.46 0 0 0-.17.64.45.45 0 0 0 .4.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.64Zm14.61 18.63-2.43-1.4a.46.46 0 0 0-.63.18.45.45 0 0 0 .17.63l2.42 1.4a.44.44 0 0 0 .24.07.47.47 0 0 0 .23-.88Zm-19.4-11.2-2.43-1.4a.47.47 0 0 0-.46.81L195 424a.53.53 0 0 0 .23.06.47.47 0 0 0 .41-.23.47.47 0 0 0-.13-.63Zm-1.68-3.69a.45.45 0 0 0-.63-.17l-2.43 1.4a.46.46 0 0 0-.17.63.47.47 0 0 0 .4.24.44.44 0 0 0 .24-.07l2.42-1.4a.45.45 0 0 0 .17-.63Zm8.15 7.43-2.43-1.4a.46.46 0 0 0-.64.17.46.46 0 0 0 .17.63l2.43 1.4a.39.39 0 0 0 .23.07.49.49 0 0 0 .41-.24.46.46 0 0 0-.15-.63Zm11.25-18.64a.46.46 0 0 0-.63-.17l-2.43 1.4a.47.47 0 0 0-.17.64.49.49 0 0 0 .41.24.41.41 0 0 0 .23-.07l2.42-1.4a.46.46 0 0 0 .17-.64Zm-4.79 22.37-2.42-1.4a.47.47 0 1 0-.47.81l2.43 1.4a.46.46 0 0 0 .23.06.45.45 0 0 0 .4-.23.46.46 0 0 0-.17-.64ZM206.77 412a.47.47 0 0 0-.64-.17l-2.42 1.4a.46.46 0 0 0 .23.87.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.64Zm51.33-26.13a.46.46 0 0 0 .23-.87l-.43-.25c.7-.6.6-1.43-.32-2a4.24 4.24 0 0 0-3.8 0 1.16 1.16 0 0 0 0 2.19 4.23 4.23 0 0 0 3.12.27l1 .56a.46.46 0 0 0 .2.14Zm21 27.6-2.43 1.4a.47.47 0 0 0 .23.88.44.44 0 0 0 .24-.07l2.42-1.4a.47.47 0 0 0-.46-.81Zm-1.62-16.4a.48.48 0 0 0 .41-.23.47.47 0 0 0-.17-.64l-2.43-1.4a.47.47 0 0 0-.47.81l2.43 1.4a.46.46 0 0 0 .25.1Zm6.47 3.74a.47.47 0 0 0 .4-.23.46.46 0 0 0-.17-.64l-2.42-1.4a.47.47 0 1 0-.47.81l2.43 1.4a.46.46 0 0 0 .28.1Zm-11.32 16.4-2.43 1.4a.47.47 0 0 0-.17.64.48.48 0 0 0 .41.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.64.46.46 0 0 0-.62-.13Zm-27.08-27.62a.47.47 0 0 0-.64-.17l-2.42 1.4a.47.47 0 0 0-.17.64.45.45 0 0 0 .4.23.53.53 0 0 0 .24-.06l2.42-1.4a.47.47 0 0 0 .19-.6Zm44.87 14.95a.45.45 0 0 0 .4-.23.47.47 0 0 0-.17-.64l-2.42-1.4a.47.47 0 0 0-.47.81l2.42 1.4a.53.53 0 0 0 .26.1Zm-4.86 5.2-2.42 1.4a.47.47 0 0 0-.17.64.45.45 0 0 0 .4.23.53.53 0 0 0 .24-.06l2.42-1.4a.47.47 0 0 0-.47-.81Zm7.11-3.56a.46.46 0 0 0-.64-.17l-2.42 1.4a.45.45 0 0 0-.17.63.46.46 0 0 0 .4.24.39.39 0 0 0 .23-.07l2.43-1.4a.46.46 0 0 0 .19-.59ZM252 385.9a.47.47 0 0 0-.64-.17l-2.42 1.4a.46.46 0 0 0-.17.64.45.45 0 0 0 .4.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0 .17-.64Zm1.21 42.55-2.43 1.4a.47.47 0 0 0-.17.64.48.48 0 0 0 .41.23.46.46 0 0 0 .23-.06l2.42-1.4a.46.46 0 0 0 .17-.64.46.46 0 0 0-.59-.17Zm-6.47 3.73-2.43 1.4a.47.47 0 0 0-.17.64.48.48 0 0 0 .41.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0-.47-.81Zm17.79-42.53a.46.46 0 0 0 .4-.24.45.45 0 0 0-.17-.63l-2.42-1.4a.46.46 0 1 0-.47.8l2.43 1.4a.39.39 0 0 0 .27.07Zm1.65 31.35-2.42 1.4a.46.46 0 0 0-.17.64.45.45 0 0 0 .4.23.46.46 0 0 0 .23-.06l2.43-1.4a.47.47 0 0 0-.47-.81Zm-6.47 3.74-2.42 1.4a.47.47 0 0 0 .23.87.44.44 0 0 0 .24-.07l2.42-1.4a.46.46 0 1 0-.47-.8ZM271 393.38a.46.46 0 0 0 .4-.23.47.47 0 0 0-.17-.64l-2.43-1.4a.47.47 0 0 0-.46.81l2.42 1.4a.53.53 0 0 0 .24.06Z",
    style: {
      opacity: 0.2,
      transformOrigin: "241.635px 412.521px"
    },
    className: "animable",
    id: "freepik--Selection--inject-33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-33",
    className: "animable",
    style: {
      transformOrigin: "317.295px 412.295px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.78 394.84-62.9 4.92a2.59 2.59 0 0 0-2.35 2.54v4.16a4.14 4.14 0 0 0 2.12 3.4l40 19.66a1.57 1.57 0 0 0 2.41-1.3l.82-6.43a2.3 2.3 0 0 1 2.63-2l19.22 2.83a4.77 4.77 0 0 0 3.88-1.44l2.91-3.37a7.27 7.27 0 0 0 1.55-4.15v-4.15a2.83 2.83 0 0 0-2.34-2.71l-9-1.33 1.72-1a4.11 4.11 0 0 0 1.72-3.33V397a2.15 2.15 0 0 0-2.39-2.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "317.3px 412.295px"
    },
    id: "elvgobm1mo2uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.78 394.84-62.9 4.92a2.59 2.59 0 0 0-2.35 2.54v4.16a4.14 4.14 0 0 0 2.12 3.4l40 19.66a1.57 1.57 0 0 0 2.41-1.3l.82-6.43a2.3 2.3 0 0 1 2.63-2l19.22 2.83a4.77 4.77 0 0 0 3.88-1.44l2.91-3.37a7.27 7.27 0 0 0 1.55-4.15v-4.15a2.83 2.83 0 0 0-2.34-2.71l-9-1.33 1.72-1a4.11 4.11 0 0 0 1.72-3.33V397a2.15 2.15 0 0 0-2.39-2.16Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "317.3px 412.295px"
    },
    className: "animable",
    id: "elkbwj8ndsc9o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6 413.54v8.86a4.43 4.43 0 0 1-1.88.22l-19.21-2.83a2.37 2.37 0 0 0-1.38.26v-8.92a2.31 2.31 0 0 1 1.38-.22l19.21 2.83a4.26 4.26 0 0 0 1.88-.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "337.365px 416.763px"
    },
    className: "animable",
    id: "eliz1wsn8v6o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.83 420.83v8.88a1.79 1.79 0 0 1-1.19-.19l-40-19.66a4.14 4.14 0 0 1-2.12-3.4v-4.16A2.62 2.62 0 0 1 281 400c-.29.24-.06.6.69 1l40 19.66a1.85 1.85 0 0 0 1.14.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "301.175px 414.87px"
    },
    className: "animable",
    id: "elub1syxrs3us"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.78 394.84-62.9 4.92c-1.3.1-1.4.65-.23 1.22l40 19.67a1.58 1.58 0 0 0 2.41-1.31l.82-6.43a2.3 2.3 0 0 1 2.63-2l19.22 2.82a4.77 4.77 0 0 0 3.88-1.44l2.91-3.37c.86-1 .5-1.94-.79-2.13L333.5 404c-1.29-.19-1.41-.86-.27-1.5l11.84-6.66c1.14-.66 1.01-1.1-.29-1Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "317.411px 407.856px"
    },
    className: "animable",
    id: "eltnps7p54pz"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttachments);
export default __webpack_public_path__ + "static/media/noAttachments.8d738e69b4ec0ca9292497a62f6f1243.svg";
export { ForwardRef as ReactComponent };